import { useQuery } from "@tanstack/react-query";
import { goldenRatioMultiplierChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { GoldenRatioMultiplierQueryParams } from "@/types/indices";

export const useGoldenRatioMultiplierChart = (params?: GoldenRatioMultiplierQueryParams) => {
  return useQuery(goldenRatioMultiplierChartQueryOptions(params));
};
